import Vue from "vue";
import Axios from "axios";
import store from "../store";
import i18n from "../lang";

function getCookie(name) {
  var strcookie = document.cookie.replaceAll("result_code=;", ""); //获取cookie字符串
  console.log(document.cookie);
  var arrcookie = strcookie.split("; "); //分割
  //遍历匹配
  for (var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split("=");
    if (arr[0] == name) {
      return arr[1];
    }
  }
  return "";
}

function prepare() {
  var token =
    "" +
    (token = new Date()).getFullYear() +
    token.getMonth() +
    token.getDate();
  var scriptDom = document.createElement("script");
  scriptDom.src =
    "https://source.s5.udesk.cn/ticket_sdk/ticket_sdk.js?t=" + token;
  document.body.appendChild(scriptDom);
  //sdk固定 查找文档 https://www.udesk.cn/doc/thirdparty/ticket_sdk/
  scriptDom.addEventListener(
    "load",
    () => {
      Vue.prototype.$udesk.isReady = true;
    },
    false
  );
}

function init() {
  // 获取当前地址
  const currentURL = window.location.href;

  // 判断并设置 preferredLang
  if (currentURL.includes("cn-northwest")) {
    localStorage.setItem("preferredLang", "zh");
  } else if (currentURL.includes("ap-east")) {
    localStorage.setItem("preferredLang", "en");
  } else if (!localStorage.getItem("preferredLang")) {
    if (currentURL.includes(".com")) {
      localStorage.setItem("preferredLang", "en");
    } else if (currentURL.includes(".cn")) {
      localStorage.setItem("preferredLang", "zh");
    }
  }
  var count = 0;
  Axios({
    method: "post",
    url: Vue.prototype.$backend.host,
    headers: {
      jwt: localStorage.getItem("result_code"),
      "x-source": "Nemo",
    },
    data: {
      Operation: "GetAccountInfo",
    },
  })
    .then((res) => {
      gtag("event", "user_login", {
        login_method: "GetAccountInfo",
        code: res.data.code ? res.data.code : "success",
      });
      console.log("jwt验证返回：", res.data);
      if (res.data.code) {
        //返回错误代码 jwt过期 8小时
        count = 3;
        console.log("Logout");
        store.commit("Logout");
      } else {
        //重新登录
        store.commit("LOGIN", res.data);

        var my_signature = res.data.signature;
        var user_token = res.data.custId;
        store.commit("SaveToken", res.data.custId);
        count++;
        console.log("重新登陆");
        // init sdk
        console.log(user_token);
        Vue.prototype.$udesk.sdk = UdeskSDK.ticketSDK.init({
          subdomain: "source.s5.udesk.cn",
          appid: "03e234975a2f9e72",
          signature: my_signature,
          type: "token",
          lang: localStorage.getItem("preferredLang") == "zh" ? "" : "en-us",
          content: user_token,
        });
        //Udesk 获取工单列表
        Vue.prototype.$udesk.sdk
          .request()
          .getConfig()
          .then((result) => {
            //TicketForm 获取 完整工单需要自己拼凑
            console.log(result);
            var lang = localStorage.getItem("preferredLang") == "zh" ? 39 : 38;
            Vue.prototype.$udesk.sdk
              .request()
              .getTicketFormConfig(lang)
              .then((res) => {
                Axios({
                  method: "post",
                  url: Vue.prototype.$backend.host,
                  headers: {
                    jwt: localStorage.getItem("result_code"),
                    "x-source": "Nemo",
                  },
                  data: {
                    Query:
                      "{ getUdeskFormTemplates (formIds: [" +
                      lang +
                      "]) {templates} }",
                  },
                }).then((res3) => {
                  console.log(res3);
                  count++;
                  var result3 = JSON.parse(
                    res3.data.result.getUdeskFormTemplates.templates[0]
                  ).template.custom_fields;
                  console.log("接口获取字段", result3);
                  console.log("Udesk 获取工单列表result ：", result);
                  console.log("Ticket 填写工单页字段  res:", res);
                  const ticketList = [];
                  const ticketLists = [];
                  store.commit("SaveTicketFields", result.ticket_fields);
                  res.ticket_plugin_form.form_fields.map((field) => {
                    for (const index in result.ticket_fields) {
                      var field_detail = "";
                      result3.map((res) => {
                        if (res.field_name == index) {
                          field_detail = res.field_detail;
                        }
                      });
                      if (index == field.field_name) {
                        var value = result.ticket_fields[index];
                        var config = field;
                        var obj = { value, config, field_detail };
                        ticketList.push(obj);
                      }
                    }
                  });
                  store.commit("GetTicketFields", ticketList);
                  console.log(ticketList);
                  store.commit(
                    "GetTicketPlugin",
                    result.ticket_plugin.detail_fields
                  );
                  for (
                    let index = 0;
                    index < result.ticket_plugin.list_fields.length;
                    index++
                  ) {
                    for (const index2 in result.ticket_fields) {
                      if (result.ticket_plugin.list_fields[index] == index2) {
                        ticketLists.push({
                          list_fields: result.ticket_fields[index2].field_label,
                          ticket_fields: index2,
                        });
                      }
                    }
                  }
                  console.log(ticketLists);

                  if (localStorage.getItem("preferredLang") === "zh") {
                    // Filter out objects with "ticket_fields": "TextField_2078" for zh
                    const filteredData = ticketLists.filter(
                      (item) => item.ticket_fields !== "TextField_2078"
                    );
                    console.log(filteredData);
                    store.commit("SetListSub", filteredData);
                  } else if (localStorage.getItem("preferredLang") === "en") {
                    const replacedData = ticketLists
                      .map((item) => {
                        if (item.ticket_fields === "TextField_1371") {
                          return {
                            list_fields: "Subject",
                            ticket_fields: "TextField_2078",
                          };
                        } else if (item.ticket_fields === "TextField_2078") {
                          return undefined; // Remove the original object
                        }
                        return item;
                      })
                      .filter((item) => item !== undefined);
                    console.log(replacedData);
                    store.commit("SetListSub", replacedData);
                  } else {
                    console.log("Invalid language");
                    store.commit("SetListSub", ticketLists);
                  }
                });
              
              });
          });
        count++;
        
      }
    })
    .catch((err) => {
      //返回错误代码 jwt过期 8小时
      count = 3;
      console.log("Logout");
      store.commit("Logout");
    });
  var countr = 0;
  let timer = setInterval(() => {
    countr++;
    if (countr >= 50) {
      console.log(count);
      clearInterval(timer);
    }
    if (count == 3) {
      Vue.prototype.$udesk.getDataReady = true;
      clearInterval(timer);
      console.log("udesk完成");
    }
  }, 200);
}

prepare();

//全局udesk 元素
Vue.prototype.$udesk = {
  isReady: false,
  getDataReady: false,
  sdk: null,
  init,
};
